import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './homepage';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import FaqPage from './pages/FaqPage';
import BreakingNewsProblemPage from './pages/BreakingNewsProblemPage';
import SafetyDataGuidePage from './pages/SafetyDataGuidePage';
import HealthEnvironmentalGuidePage from './pages/HealthEnvironmentalGuidePage';
import MetaPixelPageView from './components/MetaPixelPageView';
import './HomePage.css';

const App: React.FC = () => (
  <BrowserRouter>
    <MetaPixelPageView />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/subscription/success" element={<CheckoutSuccess />} />
      <Route path="/subscription/cancel" element={<CheckoutCancel />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/breaking-news-problem" element={<BreakingNewsProblemPage />} />
      <Route path="/public-safety-data" element={<SafetyDataGuidePage />} />
      <Route path="/health-environmental-data" element={<HealthEnvironmentalGuidePage />} />
    </Routes>
  </BrowserRouter>
);

export default App;

